import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  background-color: ${props => props.backgroundColor};
  color: ${props => props.textColor};
  font-size: ${props => props.theme.texts.bodySRegular};
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;

  img {
    height: 28px;
    width: 60px;
  }

  p {
    margin: 0;
  }

  a {
    color: ${props => props.linkColor};
    font-family: ${props => props.theme.texts.bodySRegular.fontFamily};
    font-weight: 700;
  }
`
